import React, { useEffect, useState } from "react";
import Loading from "components/loading";
import { getData, upload } from "api/upload";
import { NoticeContainer, UploaderContainer } from "./style";
import { IoCloudUploadOutline } from "react-icons/io5";
const status = {
  pending: "در انتظار تایید",
  approve: "تایید شده",
  reject: "رد شده",
};
const UploadPage = () => {
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState("");
  const [data, setData] = useState([]);
  useEffect(() => {
    getData()
      .then((res) => {
        setData(res.data);
        setLoading(false);
      })
      .catch((err) => {});
  }, []);
  const handleChange = (e, usage) => {
    if (e.target.files[0].size > 1045000) {
      alert("حجم فایل انتخاب شده بیشتر از حد مجاز است");
    } else {
      setUploading(usage);
      upload(e.target.files[0], usage)
        .then((res) => {
          setData(res.data);
        })
        .finally(() => {
          setUploading("");
        });
    }
  };
  const imageView = (data) => {
    if (data.src && data.src !== "") {
      return (
        <div className="img">
          <img src={(data.type === 'image')?data.src :'/images/pdf-icon.png' } alt={data.title} />
          {data.status === "reject" && (
            <IoCloudUploadOutline className="floated" />
          )}
        </div>
      );
    } else {
      return <IoCloudUploadOutline />;
    }
  };
  console.log(data);
  if (loading) {
    return <Loading />;
  } else {
    return (
      <>
        {data.map((item, key) => {
          return (
            <UploaderContainer className="" key={key}>
              <div className="title-area">
                {item.title}:
                {item.description ? (
                  <div
                    className="description"
                    dangerouslySetInnerHTML={{ __html: item.description }}
                  />
                ) : (
                  ""
                )}
              </div>
              <div className="items">
                {item.items.map((value, index) => (
                  <div
                    className={`item ${
                      uploading === value.usage ? "uploading" : ""
                    }`}
                    key={index}
                  >
                    <label
                      className={
                        (value.status !== "reject" &&
                          value.status !== "" &&
                          value.status) ||
                        value.status === "approve"
                          ? "disabled"
                          : ""
                      }
                    >
                      {imageView(value)}
                      <input
                        className="upload-input"
                        type="file"
                        accept="image/png, image/gif, image/jpeg, application/pdf"
                        onChange={(e) => {
                          handleChange(e, value.usage);
                        }}
                        disabled={
                          (value.status !== "reject" &&
                            value.status !== "" &&
                            value.status &&
                            uploading === value.usage) ||
                          value.status === "approve"
                        }
                      />
                    </label>
                    <div className="title">{value.title}</div>
                    {value.status !== "" && value.status ? (
                      <div className={`status ${[value.status]}`}>
                        {status[value.status]}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ))}
              </div>
            </UploaderContainer>
          );
        })}
        <NoticeContainer>
          حداکثر حجم فایل قابل آپلود ۱ مگابایت است.
        </NoticeContainer>
      </>
    );
  }
};
export default UploadPage;
